<template>
  <app-wrapper>
    <app-header :loan="loan" medium-max-width="max-w-1000">
      <template #navigation>
        <div class="max-w-200">
          <h5 class="font-zen-dots text-white">
            <AppLogo/>
          </h5>
        </div>
      </template>
      <template #top>
        <div class="w-full flex items-center">
          <div class="flex-auto">
            Your desired loan amount
            <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
          </div>
          <div class="flex-initial">
            <i class="fa fa-check-circle text-success text-7xl"/>
          </div>
        </div>
      </template>
    </app-header>

    <app-body medium-max-width="max-w-500" footer>
      <template #title>
        Verify Income In Process...
      </template>

      <template #text>
        <div>
          <div class="flex items-center mb-3">
            <i class="fa fa-info-circle text-info text-2xl"/>
            <p class="ml-2">This can take a few minutes</p>
          </div>
        </div>
      </template>

      <template #main>
        <div v-if="showSlowMessage" class="mb-4">
          <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p class="text-yellow-700 text-sm">This is taking longer than expected. Please contact support if the issue persists.</p>
          </div>
        </div>
        <WaitingProgressBar :show-progress="true" :progressDuration="180" :progressTexts="[
          'Starting verification...',
          'Analyzing financial data...',
          'Validating income sources...',
          'Checking fraud risk...',
          'Finalizing report...',
          'Preparing results...',
          'Decision pending...'
        ]"/>
      </template>
    </app-body>
  </app-wrapper>
</template>

<script>
import AppLogo from './../../../components/AppLogo';
import WaitingProgressBar from '../../../components/WaitingProgressBar.vue';

export default {
  mixins: [
    require('../../../mixins/InteractsWithGtag').default,
    require('../../../mixins/PageViewAnalytics').default
  ],
  components: {
    AppLogo,
    WaitingProgressBar,
  },
  props: {
    user: {},
    loan: {},
    manual: {
      type: Boolean,
      default: false,
    },
    customAiMode: {
      type: Boolean,
      default: false,
    },
    statusCheckUrl: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      gTagPageName: 'VERIFY_INCOME_PROCESSING',
      pollInterval: null,
      lastStatus: null,
      reloading: false,
      pollStartedAt: null,
      showSlowMessage: false,
    };
  },

  created() {
    if (this.customAiMode && this.statusCheckUrl) {
      this.startPolling();
    }
  },

  beforeDestroy() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  },

  methods: {
    async checkStatus() {
        if (this.reloading) return;

        const elapsed = Date.now() - this.pollStartedAt;
        // Show slow message after 5 minutes
        if (elapsed > 5 * 60 * 1000) {
          this.showSlowMessage = true;
        }
        // Force reload after 15 minutes — controller will show correct page.
        // Server-side in-flight gate releases at CustomPaystubUpload::WEBHOOK_WAIT_MINUTES (30 min);
        // if that constant changes, update this hard-stop manually — no auto-sync.
        if (elapsed > 15 * 60 * 1000) {
          clearInterval(this.pollInterval);
          this.reloading = true;
          window.location.reload();
          return;
        }

        try {
          const response = await axios.get(this.statusCheckUrl);
          const status = response.data.status;
          const currentStatus = JSON.stringify(response.data);

          // Reload on any terminal status (not processing/waiting)
          if (['rejected', 'error', 'completed'].includes(status)) {
            this.reloading = true;
            window.location.reload();
            return;
          }

          // Also reload if status changed while still processing (e.g. ai → plaid stage)
          if (this.lastStatus !== null && this.lastStatus !== currentStatus) {
            this.reloading = true;
            window.location.reload();
            return;
          }
          this.lastStatus = currentStatus;
        } catch (e) {
          // Silently ignore polling errors
        }
    },
    startPolling() {
      this.pollStartedAt = Date.now();
      this.checkStatus();
      this.pollInterval = setInterval(() => this.checkStatus(), 10000);
    },
  },
};
</script>